import { ArrowRight } from 'lucide-react';
import whatsappLogo from '../assets/whatsapp-logo.svg';

const CALENDAR_URL = 'https://calendar.app.google/DtBNRYcoX9a3oD5a9';
const WHATSAPP_URL =
	'https://wa.me/919351275556?text=Hi%2C%20I%27d%20like%20to%20enquire%20about%20your%20India-UK%20tax%20advisory%20services.';

const CTASection = () => {
	return (
		<section
			data-testid='cta-section'
			id='contact'
			aria-label='Contact us to schedule a consultation'
			className='py-20 relative overflow-hidden'
			style={{
				background:
					'linear-gradient(135deg, #1E3F6B 0%, #2D5A8C 50%, #3A72A8 100%)',
			}}>
			{/* Decorative circles */}
			<div
				className='absolute -top-20 -right-20 w-80 h-80 rounded-full opacity-10 pointer-events-none'
				style={{ backgroundColor: '#F59E0B' }}
			/>
			<div
				className='absolute -bottom-16 -left-16 w-64 h-64 rounded-full opacity-10 pointer-events-none'
				style={{ backgroundColor: '#1B8A96' }}
			/>

			<div className='max-w-4xl mx-auto px-6 text-center relative'>
				<p className='text-xs font-semibold uppercase tracking-widest mb-4 opacity-70 text-white'>
					Get Started Today
				</p>
				<h2
					className='text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-5'
					style={{ fontFamily: "'Outfit', sans-serif" }}>
					Ready to Navigate Global Taxation?
				</h2>
				<p className='text-base sm:text-lg mb-10 opacity-80 text-white max-w-2xl mx-auto leading-relaxed'>
					Schedule a free consultation with our India-UK tax specialists. We
					will assess your situation, identify DTAA opportunities, and build a
					strategy that works across both jurisdictions.
				</p>
				<div className='flex flex-col sm:flex-row gap-4 justify-center'>
					<a
						data-testid='cta-primary-button'
						href={CALENDAR_URL}
						target='_blank'
						rel='noopener noreferrer'
						className='inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold text-sm transition-all duration-200 hover:shadow-2xl hover:-translate-y-0.5 active:scale-95'
						style={{ backgroundColor: '#F59E0B', color: '#FFFFFF' }}>
						Schedule Your Free Consultation
						<ArrowRight size={16} />
					</a>
					<a
						data-testid='cta-whatsapp-button'
						href={WHATSAPP_URL}
						target='_blank'
						rel='noopener noreferrer'
						className='inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold text-sm text-white transition-all duration-200 hover:shadow-2xl hover:-translate-y-0.5 active:scale-95'
						style={{ backgroundColor: '#25D366' }}>
						<img src={whatsappLogo} alt='' className='w-6 h-6 -mx-1' />
						Chat on WhatsApp
					</a>
					<a
						data-testid='cta-secondary-button'
						href='mailto:Info@ghiyaassociates.com'
						className='inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold text-sm border-2 border-white text-white transition-all duration-200 hover:bg-white hover:text-blue-900'>
						Send Us a Message
					</a>
				</div>
				<p className='mt-8 text-xs opacity-60 text-white'>
					No commitment required. Free 30-minute initial consultation.
				</p>
			</div>
		</section>
	);
};

export default CTASection;
